module.exports = __webpack_public_path__ + "static/img/bg-left.d99e9e4f.png";